<template>
  <div class="layout" >
    <router-view/>
    <!-- Load Facebook SDK for JavaScript -->
    <div id="fb-root"></div>
    <!-- Your Chat Plugin code -->
    <div class="fb-customerchat"
         attribution="setup_tool"
         page_id="">
    </div>
  </div>
</template>
<script>
// window.fbAsyncInit = function() {
//   FB.init({
//     xfbml            : true,
//     version          : 'v10.0'
//   });
// };
//
// (function(d, s, id) {
//   var js, fjs = d.getElementsByTagName(s)[0];
//   if (d.getElementById(id)) return;
//   js = d.createElement(s); js.id = id;
//   js.src = 'https://connect.facebook.net/zh_TW/sdk/xfbml.customerchat.js';
//   fjs.parentNode.insertBefore(js, fjs);
// }(document, 'script', 'facebook-jssdk'));
export default {
  name: 'app',
  components: {},
  data() {
    return {
    }
  },
  computed: {
  },
  created(){
    this.$store.dispatch('actionGetProductInfo', {})

  },
  methods: {


  }
}
</script>

<style lang="scss">

  /*@import '../node_modules/awesome-bootstrap-checkbox';*/

  /*@import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC');*/


</style>
